/* Журнал LUX: цены в карточках товаров внутри статей подтягиваются с витрины (актуальная цена и валюта посетителя) */
document.addEventListener('DOMContentLoaded', function () {
  var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
  var fmt = function (cents) {
    try { return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: cur, maximumFractionDigits: 0 }).format(cents / 100); }
    catch (e) { return Math.round(cents / 100) + ' ' + cur; }
  };
  document.querySelectorAll('.lx a.item[href*="/products/"], .lx .lx-grid a[href*="/products/"]').forEach(function (a) {
    var i = a.querySelector('i'); if (!i) return;
    var url = a.getAttribute('href').split('?')[0] + '.js';
    fetch(url).then(function (r) { return r.ok ? r.json() : null; }).then(function (p) {
      if (!p) return;
      var note = (i.textContent.split(' · ')[1] || '');
      i.textContent = (p.price_varies ? 'From ' : '') + fmt(p.price_min) + (note ? ' · ' + note : '');
    }).catch(function () {});
  });
});
